// extracted by mini-css-extract-plugin
export default {"wrapper":"FinishStats_wrapper__1fuJZ"};